/**
 * Blog filter UI — dropdown open/close + active-tag pill removal.
 *
 * All handlers are delegated from `document`, so they keep working after
 * blog-ajax.js swaps #BlogContent (no re-binding needed).
 */
(function () {
  function closeDropdowns(except) {
    document.querySelectorAll('.blog-filter-dropdown__content.active').forEach(function (c) {
      if (c !== except) c.classList.remove('active');
    });
    document.querySelectorAll('.blog-filter-dropdown__header.active').forEach(function (h) {
      var content = document.getElementById(h.getAttribute('data-dropdown-toggle'));
      if (!content || !content.classList.contains('active')) h.classList.remove('active');
    });
  }

  document.addEventListener('click', function (e) {
    // Toggle a dropdown
    var header = e.target.closest('.blog-filter-dropdown__header');
    if (header) {
      e.preventDefault();
      var content = document.getElementById(header.getAttribute('data-dropdown-toggle'));
      if (!content) return;
      var willOpen = !content.classList.contains('active');
      closeDropdowns(content);
      content.classList.toggle('active', willOpen);
      header.classList.toggle('active', willOpen);
      return;
    }

    // Remove an active-filter pill -> uncheck the matching box (triggers AJAX refetch)
    var removeBtn = e.target.closest('.blog-filters__tag-remove');
    if (removeBtn) {
      e.preventDefault();
      var pill = removeBtn.closest('.blog-filters__tag');
      var handle = pill && pill.dataset.tag;
      var box = handle && document.querySelector('.blog-filter-checkbox[value="' + handle + '"]');
      if (box) {
        box.checked = false;
        box.dispatchEvent(new Event('change', { bubbles: true }));
      } else if (pill) {
        pill.remove();
      }
      return;
    }

    // Click outside any dropdown closes open ones
    if (!e.target.closest('.blog-filter-dropdown')) closeDropdowns(null);
  });

  // Inline section scripts still call this; keep it as a harmless no-op.
  window.initBlogFilters = function () {};
  window.initTagRemoval = function () {};
})();
